import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { GetActiveCustomerQuery } from '../../../common/generated-types';
import { GET_ACTIVE_CUSTOMER } from '../../../common/graphql/documents.graphql';
import { DataService } from '../../providers/data/data.service';
import { StateService } from '../../providers/state/state.service';

@Component({
    selector: 'vsf-account-link',
    templateUrl: './account-link.component.html',
    // styleUrls: ['./account-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountLinkComponent implements OnInit {

    activeCustomer$: Observable<GetActiveCustomerQuery['activeCustomer']>;
    constructor(private dataService: DataService,
                private stateService: StateService) {}

    ngOnInit() {
        this.dataService.query<GetActiveCustomerQuery>(GET_ACTIVE_CUSTOMER, {}, 'network-only')
            .pipe(take(1))
            .subscribe(data => {
                if (data.activeCustomer) {
                    this.stateService.setState('signedIn', true);
                }
            });

        this.activeCustomer$ = this.stateService.select(state => state.signedIn).pipe(
            switchMap(signedIn => {
                if (!signedIn) {
                    return [undefined];
                }
                return this.dataService.query<GetActiveCustomerQuery>(GET_ACTIVE_CUSTOMER, {}, 'network-only').pipe(
                    take(1),
                    map(data => data.activeCustomer),
                );
            }),
        );
    }

    userName(customer: NonNullable<GetActiveCustomerQuery['activeCustomer']>): string {
        const { firstName, lastName, emailAddress } = customer;
        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        } else {
            return emailAddress;
        }
    }

}
